import { cloneElement } from 'react';
import { saveAs } from 'file-saver';
import PropTypes from 'prop-types';
import { invoke } from 'lodash';

const FileDownload = ({ trigger, mimeType, fileName, onContents }) => {
  const onTriggerClick = async event => {
    invoke(trigger, 'props.onClick', event);
    const contents = await onContents();
    saveAs(
      new Blob(contents instanceof Array ? contents : [contents], {
        type: mimeType,
      }),
      fileName,
    );
  };

  return cloneElement(trigger, {
    onClick: onTriggerClick,
  });
};

FileDownload.propTypes = {
  trigger: PropTypes.element.isRequired,
  mimeType: PropTypes.string.isRequired,
  fileName: PropTypes.string.isRequired,
  onContents: PropTypes.func.isRequired,
};

export default FileDownload;



// WEBPACK FOOTER //
// ./src/components/FileDownload.js